import type { HTMLAttributes, ReactNode } from 'react';

interface PanelProps extends HTMLAttributes<HTMLElement> {
  title?: string;
  headingLevel?: 2 | 3;
  children: ReactNode;
}

export function Panel({ title, headingLevel = 2, className, children, ...rest }: PanelProps) {
  const Heading = headingLevel === 2 ? 'h2' : 'h3';
  return (
    <section {...rest} className={['panel', className].filter(Boolean).join(' ')}>
      {title !== undefined && <Heading className="panel__title">{title}</Heading>}
      {children}
    </section>
  );
}
